import ToolTip from "Components/ToolTip";
import React, { useEffect, useState } from "react";
import { Label, Col, Button, Row } from "reactstrap";
import apiGlobal from "global/api.global";
import { RootState } from "index";
import { useSelector } from "react-redux";
import VoyageAdjustmentPopup from "./VoyageAdjustmentPopup";

const ApprovedVoyageAdjustment = ({ active }: any) => {
    /** State variables start */
    const [tableDetails, setTableDetails] = useState({
        size: 5,
        index: 0,
        ciiAdjustment: [],
    });
    const [count, setCount] = useState(0);
    const [adjustmentPopup, setAdjustmentPopup] = useState(false);
    const [eventState, setEventState] = useState<any>({});
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    /** State varibles end */

    /** Load approved CII adjustment events of the selected vessels */
    const loadData = async () => {
        await apiGlobal
            .get(
                `vessel_reporting_cii_adjustment/get_cii_adjustment_by_vessel/?vessel_id=${VesselID}`
            )
            .then((response) => {
                setTableDetails((prevDetails) => ({
                    ...prevDetails,
                    ciiAdjustment: response.data.filter(
                        (item: any) => item.user_approved === true
                    ),
                }));
                setCount((count) => count + 1);
            })
            .catch((err) => {
                setTableDetails((prevDetails) => ({
                    ...prevDetails,
                    ciiAdjustment: [],
                }));
            });
    };

    /** useEffect start */
    useEffect(() => {
        loadData();
    }, [VesselID, active]);
    /** useEffect end */

    /** Pagination previous */
    const handlePrevPageClick = (e: any) => {
        tableDetails.index = tableDetails?.index > 0 ? tableDetails?.index - 1 : 0;
        setCount(count + 1);
    };

    /** Pagination next */
    const handleNextPageClick = (e: any) => {
        tableDetails.index =
            tableDetails?.index <
            Math.ceil(tableDetails?.ciiAdjustment?.length / tableDetails?.size) -
            1 && tableDetails?.index + 1;
        setCount(count + 1);
    };

    /** Open-close modal */
    function tog_backdrop() {
        setAdjustmentPopup(!adjustmentPopup);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    return (
        <>
            {tableDetails?.ciiAdjustment?.length === 0 ? (
                <Label>No Voyage Adjustments available for this vessel</Label>
            ) : (
                <>
                    <Row className="mb-3">
                        <Col lg={12}>
                            <div className="table-responsive">
                                <table className="table mb-0" key={count}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Duration</th>
                                            <th>Voyage Adjustment Event</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableDetails && tableDetails?.ciiAdjustment?.slice(tableDetails?.index * tableDetails?.size,
                                            tableDetails?.index * tableDetails?.size + tableDetails?.size)?.map((cii: any, index: number) => {
                                                return (
                                                    <>
                                                        <tr key={index}>
                                                            <td className='nopadtop align-middle'>{index + 1}</td>
                                                            <td className='nopadtop align-middle'>
                                                                <>
                                                                    {cii?.cii_begin_date_time?.toString().substring(0, 10)}&nbsp;
                                                                    {cii?.cii_begin_date_time?.toString().substring(11, 16)}&nbsp;&nbsp;to&nbsp;&nbsp;
                                                                    {cii?.cii_end_date_time?.toString().substring(0, 10)}&nbsp;
                                                                    {cii?.cii_end_date_time?.toString().substring(11, 16)}
                                                                </>
                                                            </td>
                                                            <td className='nopadtop align-middle'>{cii?.cii_adjustment_name}</td>
                                                            <td className='nopadtop align-middle'>
                                                                <i className='mdi mdi-checkbox-multiple-marked-outline icon_s23' id={`cii_validate${index}`}
                                                                    onClick={() => {
                                                                        setAdjustmentPopup(true);
                                                                        setEventState(cii);
                                                                    }} />
                                                            </td>
                                                            <ToolTip target={`cii_validate${index}`} message='Validate Voyage Adjustment' />
                                                        </tr>
                                                        {
                                                            adjustmentPopup === true &&
                                                            <VoyageAdjustmentPopup
                                                                state={adjustmentPopup}
                                                                setState={setAdjustmentPopup}
                                                                toggle={tog_backdrop}
                                                                event={eventState}
                                                                target={`popup${eventState?.id}`}
                                                            />
                                                        }
                                                    </>
                                                )
                                            }
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                    {tableDetails?.ciiAdjustment?.length > tableDetails?.size &&
                        <Row>
                            <Col lg={{ size: 2, offset: 10 }} className="mt-3">
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn pos-end"
                                    onClick={(e: any) => handleNextPageClick(e)}
                                >
                                    <i className="bx bx-chevron-right" />
                                </Button>
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn ms-5"
                                    onClick={(e: any) => handlePrevPageClick(e)}
                                >
                                    <i className="bx bx-chevron-left" />
                                </Button>
                            </Col>
                        </Row>
                    }
                </>
            )}
        </>
    );
};

export default ApprovedVoyageAdjustment;
